import React from 'react';
import { object, func, array, string, oneOfType } from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty } from 'ramda';

import { hideBackButton } from '../../actions/header/headerActions';
import {
  closeAlertDialog,
  closeConfirmDialog,
  openConfirmDialog,
  openErrorDialog,
} from '../../actions/dialog/dialogActions';
import { hideFullPageLoadingState, showFullPageLoadingState } from '../../actions/loadingState/loadingStateActions';
import { fetchAuthenticatedPreferences, switchLocation } from '../../actions/preferences/preferencesAction';

import HeaderBranding from './HeaderBranding';
import HeaderPanelActions from './HeaderPanelActions';
import HeaderContentActions from './HeaderContentActions';
import Help from '../Help';
import LocationSwitcher from '../LocationSwitcher';

import s from './HeaderBar.css';


const HeaderBar = ({ ...props }) => {

  const backButtonClickHandler = () => props.hideBackButton();

  // Show Full Page LoadingState
  const handleLocationSelectionStart = () => props.showFullPageLoadingState();

  const handleLocationSelectionEnd = () => {
    // Hide Full Page LoadingState
    props.hideFullPageLoadingState();

    // Get fresh preferences
    props.fetchAuthenticatedPreferences();
  };

  return (
    <nav className={s.component}>
      <HeaderBranding
        activeRoute={props.activeRoute}
        logoUrl={props.logoUrl}
      />
      <HeaderPanelActions
        backButton={props.header.backButton}
        backButtonClickHandler={backButtonClickHandler}
        title={props.header.title} />
        {!isEmpty(props.locations) && props.authenticatedPreferences.locationsEnabled &&
          <HeaderContentActions>
            <LocationSwitcher
              activeLocation={props.activeLocation}
              locations={props.locations}
              closeConfirmDialog={props.closeConfirmDialog}
              openConfirmDialog={props.openConfirmDialog}
              handleLocationSelectionStart={handleLocationSelectionStart}
              handleLocationSelectionEnd={handleLocationSelectionEnd}
              switchLocation={props.switchLocation}
            />
          {props.authenticatedPreferences.helpUrl &&
            <Help data={props.authenticatedPreferences.helpUrl} />
          }
          </HeaderContentActions>
        }
        {!props.authenticatedPreferences.locationsEnabled && props.authenticatedPreferences.helpUrl &&
          <HeaderContentActions>
            <Help data={props.authenticatedPreferences.helpUrl} />
          </HeaderContentActions>
        }
    </nav>
  );

};

HeaderBar.propTypes = {
  activeLocation: object,
  activeRoute: string,
  authenticatedPreferences: object,
  closeAlertDialog: func,
  fetchAuthenticatedPreferences: func,
  header: object,
  hideBackButton: func,
  hideFullPageLoadingState: func,
  locations: oneOfType([
    array,
    object,
  ]),
  logoUrl: string,
  openErrorDialog: func,
  showFullPageLoadingState: func,
  switchLocation: func,
};

const mapStateToProps = (state) => ({
  header: state.header,
  locations: state.locations,
});

const mapDispatchToProps = (dispatch) => ({
  closeAlertDialog: () => dispatch(closeAlertDialog()),
  closeConfirmDialog: () => dispatch(closeConfirmDialog()),
  fetchAuthenticatedPreferences: () => dispatch(fetchAuthenticatedPreferences()),
  hideBackButton: (isEnabled) => dispatch(hideBackButton()),
  hideFullPageLoadingState: () => dispatch(hideFullPageLoadingState()),
  openConfirmDialog: dialog => dispatch(openConfirmDialog(dialog)),
  openErrorDialog: dialog => dispatch(openErrorDialog(dialog)),
  showFullPageLoadingState: () => dispatch(showFullPageLoadingState()),
  switchLocation: (newLocation, successCb, errorCb) => dispatch(switchLocation(newLocation, successCb, errorCb)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderBar);



// WEBPACK FOOTER //
// ./src/components/HeaderBar/HeaderBar.js